import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page.component';
import { HeaderModule } from '../../layout/header/header.module';
import { FooterModule } from '../../layout/footer/footer.module';
import { MobilModalModule } from '../../organisms/mobil-modal/mobil-modal.module';
import { PassoMobilModalModule } from '../../organisms/passolig-mobil-modal/passolig-mobil-modal.module';

@NgModule({
  declarations: [PageComponent],
  imports: [
    CommonModule, 
    HeaderModule,
    FooterModule,
    MobilModalModule,
    PassoMobilModalModule
  ],
  exports: [PageComponent],
})
export class PageModule {
  getComponent() {
    return PageComponent;
  }
}
